import { Grid, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { OverviewCard } from '../Info';
import { getNoteCategory, getSaveDetails } from '../../NewAlertsNotes/NoteItem';
import { useCustomerNoteEnums } from '@/hooks/useCustomerNoteEnums';
import { PinIcon } from '@/common/icons/PinIcon';
import { BaseNote } from '../../NewAlertsNotes/Types';
import { TabKey } from '../../../useCustomerProfileQueryParams';

export const useStyles: any = makeStyles(() => ({
  pinnedNoteContainer: {},
  heading: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  viewAllNotesLink: {
    color: '#055577',
    cursor: 'pointer',
    fontSize: 18
  },
  note: {
    padding: '16px',
    marginBottom: '16px',
    borderRadius: '8px',
    border: '1px solid #E0E0E0'
  },
  title: {
    color: '#999',
    height: 32,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    '& > *:first-child': {
      marginRight: '8px'
    },
    '& > *:nth-child(2)': {
      verticalAlign: 'super',
      whiteSpace: 'nowrap',
      overflow: 'ellipsis'
    }
  },
  content: {
    color: '#000',
    fontSize: 16,
    fontWeight: 400,
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    width: '100%'
  },
  saveDetails: {
    color: '#666',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1,
    marginTop: 8
  }
}));

export interface PinnedNoteProps {
  note: BaseNote;
  changeTab: (tab: TabKey) => void;
}

const PinnedNote = (props: PinnedNoteProps) => {
  const { note, changeTab } = props;

  const classes = useStyles();
  const { enums, loading } = useCustomerNoteEnums();

  return (
    <OverviewCard>
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12} className={classes.heading}>
          <Typography className={classes.headingText} color="primary">
            Pinned note
          </Typography>
          <span
            className={classes.viewAllNotesLink}
            onClick={() => changeTab('alerts_and_notes')}
          >
            View All
          </span>
        </Grid>
        <Grid item xs={12}>
          <Box p={1} className={classes.note}>
            <Grid container alignItems="center" spacing={1}>
              {!loading && (
                <>
                  <div className={classes.title}>
                    <PinIcon stroke={'#999'} />
                    <span>
                      {note.categoryId && enums
                        ? getNoteCategory(note, enums.noteCategories)
                        : 'Appointment'}
                    </span>
                  </div>
                  <div className={classes.content}>{note.content}</div>
                  <div className={classes.saveDetails}>
                    {getSaveDetails(note)}
                  </div>
                </>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default PinnedNote;
